import React from 'react';
import Footer from '../components/Footer/Footer';
import Validation from '../components/ValidationInscrip/Validation';


const Validationl = () => {
    return (
        <>
           <Validation/> 
          
        </>
    )
}

export default Validationl
